import styled from "@mui/material/styles/styled";

import Stack from "@rui/Stack";

export const Blur = styled(Stack)({
  backgroundColor: "#FFF",
  filter: "blur(4px)",
  opacity: "30%",
  minHeight: "80px",
  "&:hover": {
    cursor: "pointer",
  },
});

export const ContentContainer = styled(Stack)({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  cursor: "pointer",
});
